import { Directive, effect, inject, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { AuthPermission } from '../../core/auth/auth-permission';
import { AuthSession } from '../../core/auth/auth-session';

@Directive({
  selector: '[appPermissionGate]',
  standalone: true,
})
export class PermissionGate {
  private readonly _session = inject(AuthSession);
  private readonly _template = inject(TemplateRef<unknown>);
  private readonly _view = inject(ViewContainerRef);
  private _rendered = false;
  private _permissions: readonly AuthPermission[] = [];
  private _match: 'all' | 'any' = 'all';

  @Input({ required: true })
  set appPermissionGate(value: AuthPermission | readonly AuthPermission[]) {
    this._permissions = Array.isArray(value) ? value : [value as AuthPermission];
    this._render();
  }

  @Input()
  set appPermissionGateMatch(value: 'all' | 'any') {
    this._match = value;
    this._render();
  }

  constructor() {
    effect(() => {
      this._session.user();
      this._render();
    });
  }

  private _render(): void {
    const allowed =
      this._permissions.length > 0 &&
      (this._match === 'any'
        ? this._session.hasAnyPermission(this._permissions)
        : this._session.hasAllPermissions(this._permissions));

    if (allowed && !this._rendered) {
      this._view.createEmbeddedView(this._template);
      this._rendered = true;
    } else if (!allowed && this._rendered) {
      this._view.clear();
      this._rendered = false;
    }
  }
}
